// Copyright ©️ 2026 eVolve MEP, LLC

import { type StrongOmit, type DateOnly, today } from '@evolvemep/api-ts';
import { DateInput, type DateInputProps, type DatePickerProps, DatePicker } from '@mantine/dates';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

type DateOnlyProps = {
  value?: DateOnly | null;
  onChange: (dateOnly: DateOnly | null) => void;
  /** Minimum possible date as a `DateOnly`. */
  minDate?: DateOnly;
  /** Maximum possible date as a `DateOnly`. */
  maxDate?: DateOnly;
};

export const DateInputWrapped = ({
  value,
  onChange,
  ...props
}: DateOnlyProps & StrongOmit<DateInputProps, keyof DateOnlyProps>) => (
  <DateInput
    value={value}
    onChange={(v) => onChange(v as DateOnly)}
    defaultDate={value ?? today()}
    leftSection={<EvolveIcon icon="CalendarBoard" size={props.size ?? 'sm'} />}
    {...props}
  />
);

export const DatePickerWrapped = ({
  value,
  onChange,
  ...props
}: DateOnlyProps & StrongOmit<DatePickerProps, keyof DateOnlyProps>) => (
  <DatePicker value={value} onChange={(v) => onChange(v as DateOnly)} defaultDate={value ?? today()} {...props} />
);
